module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tasks:title-active-tasks":"Активные задачи","tasks:title-finished-tasks":"Завершенные задачи","tasks.no-active-tasks":"Активные задачи отсутствуют"},"en":{"tasks:title-active-tasks":"Active tasks","tasks:title-finished-tasks":"Finished tasks","tasks.no-active-tasks":"No active tasks"}}')
  delete Component.options._Ctor
}
